import FyForm from './form.vue'
import FyFormItem from './formItem.vue'
import FyInput from './input.vue'
import FySelect from './select.vue'
import FyCheckbox from './checkbox.vue'
import FyRadio from './radio.vue'
import FyInputDate from './inputDate.vue'
import FyFile from './file.vue'
import FyMobileDate from './mobileDate.vue'
import FyElDate from './elementDate.vue'

export {
  FyForm,
  FyFormItem,
  FyInput,
  FySelect,
  FyCheckbox,
  FyRadio,
  FyInputDate,
  FyFile,
  FyMobileDate,
  FyElDate
}



// WEBPACK FOOTER //
// ./src/components/form/index.js